/** Nota (0–10) em pt-BR, uma casa decimal. null/undefined vira "–". */
export function brPt(valor) {
  if (valor === null || valor === undefined) return "–";
  return Number(valor).toLocaleString("pt-BR", {
    minimumFractionDigits: 1,
    maximumFractionDigits: 1
  });
}

/** Cor da nota — mesmos limiares usados no restante do AVA para faixa de
    desempenho (abaixo de 6 é insuficiente, 6–8 é médio, acima é bom). */
export function corDaNota(nota) {
  if (nota === null || nota === undefined) return "var(--secondary, #8a93a2)";
  if (nota < 6) return "var(--danger, #e55353)";
  if (nota < 8) return "var(--warning, #f9b115)";
  return "var(--success, #2eb85c)";
}

export function fmtTempo(segundos) {
  const s = Number(segundos) || 0;
  const horas = Math.floor(s / 3600);
  const minutos = Math.round((s % 3600) / 60);
  if (horas === 0) return `${minutos}min`;
  return `${horas}h${minutos > 0 ? ` ${minutos}min` : ""}`;
}

export function iniciais(nome) {
  const partes = String(nome || "")
    .trim()
    .split(/\s+/);
  if (!partes[0]) return "?";
  return (partes[0][0] + (partes[1]?.[0] ?? "")).toUpperCase();
}

const PALETA_AVATAR = [
  "#02517D",
  "#00968C",
  "#f9b115",
  "#e55353",
  "#6f42c1",
  "#2eb85c"
];

export function corAvatar(seed) {
  const n = typeof seed === "number" ? seed : String(seed || "").length;
  return PALETA_AVATAR[n % PALETA_AVATAR.length];
}
